<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { useMagicKeys, whenever } from '@vueuse/core'
import {getBaseUrl} from "@/helpers/baseUrl";

export default {

  page: {
    title: "Movimento de Serviço",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect,  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      userLogged: null,
      showModalEmissao: false,
      loadingFinConta: false,
      showModalFinConta: false,
      dtListPesqFinConta: null,
      finContaData: null,

      mediasData: {},
      messageValidacaoItem: '',
      margemBruta: 0,

      showSelecionarEnder: false,
      showModalAuditoria: false,
      showModalTransp: false,
      showModalFrete: false,
      submitMovServItem: false,

      loadingCliente: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingRepres: false,
      loadingPedTipo: false,
      loadingMovServItem: false,
      loadingTransp: false,

      dtListPesqCli: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      dtListPesqRepres: null,
      dtlistPesqPedTipo: null,
      dtlistPesqMovServItem: null,
      dtListPesqTransp: null,

      showModalCliente: false,
      showModalCondPgto: false,
      showModalFormaPgto: false,
      showModalRepres: false,
      showModalPedTipo: false,
      showModalMovServItem: false,
      showModalObs: false,

      showModalCodigo: false,

      movServData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '',
        tipo: '100',
        dtemissao: new Date
      },
      clienteData: null,
      condPgtoData: {
        'codigo': '10',
        'descricao': '30 / 60 Dias'
      },
      formaPgtoData: {
        'codigo': '10',
        'descricao': 'Boleto'
      },
      pedTipoData: {
        'codigo': '100',
        'descricao': 'Compra Serviço de Terceiros'
      },
      pessoaEnderData: {},
      represData: {},
      transpData: {},
      movServItemData: {},
      movServItensData: null,

      somaMovsCli: 0,
      ultPedsData: null,
      errosValid: null,
      itensData: null,

      idData: 0,
      updating: true,
      title: "Editar Movimento de Serviço",
      items: [
        {
          text: "Movimentos",
          href: "/movservs/list",
        },
        {
          text: "Editar Movimento de Serviço",
          active: true,
        },
      ],
    };
  },
  validations: {
    movServItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'movServItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlrir': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlrcontrib': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlrpis': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlrcofins': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlriss': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.vlrinss': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movServItemData.desconto': {
      handler() {
        this.calculaTotalItem()
      }
    },


  },

  mounted() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))

    const keys = useMagicKeys()
    whenever(keys.alt_s, () => {
      if (this.movServData.status === 'EL'){
        this.salvarMovServ()
      }
    })
    whenever(keys.alt_i, () => {
      this.imprimirMovServ()
    })
    whenever(keys.alt_n, () => {
      if (this.movServData.status === 'EL') {
        this.novoProduto()
      }
    })

    console.log('mounted_movserv_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Novo Movimento de Serviço`
      this.updating = false
      let emprAtu = localStorage.getItem('empratu')
      this.movServData.empresa = emprAtu

      if (!emprAtu){
        this.movServData.empresa = '01'
      }
    }

  },

  methods:{



    gerarFinanc() {
      console.log('gerarFinanc')

      this.updating = true
      api.post(`${getBaseUrl()}api/movservgerafin`, {
        iddata: this.idData
      }).then((res) => {
        console.log('then axios gerar financ')
        console.log(res)

      })


    },


    pesqFinConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/fcontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFinConta = res.data
        });
      }
    },

    escolheuFinConta(){
      console.log('escolheuFinConta')
      console.log(this.movServData.finconta)
      api.get(`${getBaseUrl()}api/fconta`, {
        params: { coddata: this.movServData.finconta }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.finContaData = res.data[0]

      })
    },


    auditoria(){
      console.log('auditoria')
      this.showModalAuditoria = true
    },


    focusProd(){
      this.$refs.focusThis.focus()
    },


    copiarMovServ(){
      console.log('copiarMovServ')
      this.updating = true
      api.post(`${getBaseUrl()}api/movservcopy`, {
          'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.movServData = res.data

        this.idData = res.data[0].id
        this.$router.replace({ path: `/movserv/editar/${this.idData}` })
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },

    deletarMovServItem(iditem){
      console.log('deletarMovServItem')
      console.log(iditem)

      if (this.movServData.status === 'EL'){
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.delete(`${getBaseUrl()}api/movservitem`, {
              params: {
                'iddata': iditem
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)
              this.carregarDados()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de Movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    calculaTotalItem(){
      console.log('calculaTotalItem')

      // let desc = this.movServItemData.desconto
      let quant = this.movServItemData.qtd
      let vlrUnit = this.movServItemData.vlrunitliq
      //let vlrUnitTab = this.movServItemData.vlrunitbrt


      // let percDesc = 0

      if (quant > 0 && vlrUnit > 0){

        console.log('valorTotalItem')
        console.log(valorTotalItem)

        // if (vlrUnit !== vlrUnitTab){
        //   percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        // }

        let valorTotalItem0 = quant * vlrUnit


        let vlrir = this.movServItemData.vlrir ?? 0.00
        let vlrcontrib = this.movServItemData.vlrcontrib ?? 0.00
        let vlrpis = this.movServItemData.vlrpis ?? 0.00
        let vlrcofins = this.movServItemData.vlrcofins ?? 0.00
        let vlriss = this.movServItemData.vlriss ?? 0.00
        let vlrinss = this.movServItemData.vlrinss ?? 0.00
        let desconto = this.movServItemData.desconto ?? 0.00

        let valorTotalItem = valorTotalItem0 -
            vlrir - vlrcontrib - vlrpis - vlrcofins - vlriss - vlrinss - desconto


        // this.movServItemData.desconto = 0
        this.movServItemData.vlrtotalbrt = valorTotalItem0
        this.movServItemData.vlrtotalliq = valorTotalItem
        // if (percDesc > 30){
        //   this.messageValidacaoItem = 'Margem máxima de desconto atingida (30%), favor corrigir antes de confirmar'
        // } else {
        //   this.messageValidacaoItem = ''
        // }

      }

    },

    confMovServItem(){
      console.log('confMovServItem: ' + this.idData)
      this.v$.$touch()
      this.submitMovServItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.movServItemData.empresa = this.movServData.empresa
        this.loadingMovServItem = true

        api.post(`${getBaseUrl()}api/movservitem`, {
          movServItemData: this.movServItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingMovServItem = false
          this.showModalMovServItem = false
          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          console.log(err.response)
          console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })

      }
    },

    novoProduto(){
      console.log('novoProduto: ' + this.idData)

      if (this.idData === 0){

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar o movimento antes de adicionar item",
          showConfirmButton: false,
          timer: 1500
        })

      }else{
        this.movServItemData = {}
        this.showModalMovServItem = true

      }


    },

    detalhesProduto(idProd){
      console.log('detalhesProduto: ' + idProd)

      this.$router.push(`/produto/detalhe/${idProd}`);

      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);


    },

    editarProduto(idProd){
      console.log('editarProduto: ' + idProd)

      if (this.movServData.status === 'EL'){
        this.showModalMovServItem = true
        this.loadingMovServItem = true

        api.get(`${getBaseUrl()}api/movservitem`, {
          params: { iddata: idProd }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data[0])

          this.movServItemData = res.data[0]

          if (this.movServItemData.imgs){
            let imgTrat = this.movServItemData.imgs.split(',')
            this.movServItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          }

          this.loadingMovServItem = false
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarMovServ(){
      console.log('confirmarMovServ: ' + this.idData)

      if (!this.movServData.codigo){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor adicionar número ao documento antes de confirmar ",
          showConfirmButton: false,
          timer: 1500
        })
      } else {



        if (!this.movServItensData || this.movServItensData.length <= 0){
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor adicionar produto ao movimento antes de confirmar",
            showConfirmButton: false,
            timer: 1500
          })
        }else{
          Swal.fire({
            position: "center",
            icon: "question",
            title: "Confirmação de Movimento",
            text: "Esta operação é irreversível, tem certeza que deseja continuar?",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,
          }).then(result => {
            if (result.value) {
              this.updating = true
              api.post(`${getBaseUrl()}api/movservconf`, {
                iddata: this.idData
              }).then((res) => {
                console.log('then axios')
                console.log(res)
                // let movServId = res.data[0]
                this.updating = false
                this.carregarDados()
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Movimento confirmado com sucesso",
                  showConfirmButton: false,
                  timer: 1500
                })
              })
            }
          })
        }
      }

    },
    cancelarMovServ(){
      console.log('cancelarMovServ: ' + this.idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Movimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          if (this.idData > 0){
            this.updating = true
            api.post(`${getBaseUrl()}api/movservcanc`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)
              this.movServData = res.data[0]
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento cancelado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })
          }else{
            this.$router.go(-1)
          }


        }
      })
    },
    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },
    alteraObs(){
      console.log('alteraObs')
      if (this.movServData.status === 'EL'){
        this.showModalObs = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    alteraCodigo(){
      console.log('alteraCodigo')
      if (this.movServData.status === 'EL'){
        this.showModalCodigo = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    alteraTransp(){
      console.log('alteraTransp')
      if (this.movServData.status === 'EL'){
        this.showModalTransp = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    alteraFrete(){
      console.log('alteraFrete')
      if (this.movServData.status === 'EL'){
        this.showModalFrete = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    carregarDados(){
      api.get(`${getBaseUrl()}api/movserv`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios _movservEditar')
        console.log(res.data)
        this.movServData = res.data[0]
        this.clienteData = res.data[1]
        this.pedTipoData = res.data[2]
        this.formaPgtoData = res.data[3]
        this.condPgtoData = res.data[4]
        this.movServItensData = res.data[5]
        this.represData = res.data[6]


        this.finContaData = res.data[7]


        let valorTotal = 0
        let margemTotal = 0
        if (this.movServItensData.length > 0){
          this.movServItensData.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

            // console.log(value.vlrtotalliq);
            let valor = parseFloat(value.vlrtotalliq)
            valorTotal += valor

            if (value.margem){
              let valorMargem = parseFloat(value.margem)
              margemTotal += valorMargem
            }

          })
        }

        this.valorTotalItens = valorTotal
        this.margemBruta = margemTotal

        this.idData = this.movServData.id
        this.title = `Editar Movimento de Serviço (${this.movServData.id}) ${this.clienteData.nome}`
        this.updating = false
      });
    },
    selecionaCli(){
      console.log('selecionaCli')
      if (this.movServData.status === 'EL'){
        this.showModalCliente = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaCondPgto(){
      console.log('selecionaCondPgto')
      if (this.movServData.status === 'EL') {
        this.showModalCondPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaFormaPgto(){
      console.log('selecionaFormaPgto')
      if (this.movServData.status === 'EL') {
        this.showModalFormaPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaPedTipo(){
      console.log('selecionaPedTipo')
      if (this.movServData.status === 'EL') {
        console.log(this.movServData.tipo)
        this.showModalPedTipo = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaRepres(){
      console.log('selecionaRepres')
      if (this.movServData.status === 'EL') {
        console.log(this.movServData.repres)
        this.showModalRepres = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaTransp(){
      console.log('selecionaTransp')
      if (this.movServData.status === 'EL') {
        console.log(this.movServData.repres)
        this.showModalTransp = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaMovServItem(){
      console.log('selecionaMovServItem')
      if (this.movServData.status === 'EL') {
        this.showModalMovServItem = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de movimento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarCliente(){
      console.log('confirmarCliente')
      this.showModalCliente = false
      this.salvarMovServ()
    },
    confirmarCondPgto(){
      console.log('confirmarCondPgto')
      this.showModalCondPgto = false
    },
    confirmarFormaPgto(){
      console.log('confirmarFormaPgto')
      this.showModalFormaPgto = false
    },
    confirmarPedTipo(){
      console.log('confirmarPedTipo')
      this.showModalPedTipo = false
    },
    confirmarRepres(){
      console.log('confirmarRepres')
      this.showModalRepres = false
    },
    confirmarTransp(){
      console.log('confirmarTransp')
      this.showModalTransp = false
    },
    confirmarMovServItem(){
      console.log('confirmarMovServItem')
      this.showModalMovServItem = false
    },
    confirmarFrete(){
      console.log('confirmarFrete')
      this.showModalFrete = false
      this.salvarMovServ()

    },

    pesqCliente(evt){
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },

    pesqCondPgto(evt){
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingCondPgto = true
        this.movServData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    pesqFormaPgto(evt){
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingFormaPgto = true
        this.movServData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },

    pesqPedTipo(evt){
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingPedTipo = true
        this.movServData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query, t: 'S', f: this.movServData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    pesqRepres(evt){
      console.log('pesqRepres')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingRepres = true
        this.movServData.repres = ''
        api.get(`${getBaseUrl()}api/reprpesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqRepres = res.data
        })
      }
    },

    pesqTransp(evt){
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true
        this.movServData.transp = ''
        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqTransp = res.data
        })
      }
    },

    pesqMovServItem(evt){
      console.log('pesqMovServItem')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqMovServItem = null
        this.loadingMovServItem = true
        api.get(`${getBaseUrl()}api/prodpesqserv`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqMovServItem = res.data

          this.dtlistPesqMovServItem.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

          });

        })
      }
    },

    escolheuCli(){
      console.log('escolheuCli')
      this.loadingCliente = true
      console.log(this.movServData.fornec)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.movServData.fornec }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaMovsCli = totalPed
        this.loadingCliente = false
      })
    },

    escolheuCondPgto(){
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      console.log(this.movServData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.movServData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaMovsCli = totalPed
        this.loadingCondPgto = false
      })
    },

    escolheuFormaPgto(){
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      console.log(this.movServData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: this.movServData.formapgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaMovsCli = totalPed
        this.loadingFormaPgto = false
      })
    },

    escolheuPedTipo(){
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.movServData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.movServData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaMovsCli = totalPed
        this.loadingPedTipo = false
      })
    },

    escolheuRepres(){
      console.log('escolheuRepres')
      this.loadingRepres = true
      console.log(this.movServData.repres)
      api.get(`${getBaseUrl()}api/reprcod`, {
        params: { coddata: this.movServData.repres }
      }).then((res) => {
        console.log('then axios_escolheu_repres')
        console.log(res.data)
        this.represData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaMovsCli = totalPed
        this.loadingRepres = false
      })
    },

    escolheuTransp(){
      console.log('escolheuTransp')
      this.loadingTransp = true
      console.log(this.movServData.transp)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.movServData.transp }
      }).then((res) => {
        console.log('then axios_escolheu_transp')
        console.log(res.data)
        this.transpData = res.data[0]
        this.loadingTransp = false
      })
    },

    escolheuMovServItem(){
      console.log('escolheuItem')
      this.loadingMovServItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.movServItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)

        let img1 = ''
        if (res.data[0]['imgs']){
          img1 = res.data[0]['imgs']
        }

        this.movServItemData = {
          movserv_id: this.idData,
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          saldo: res.data[0]['saldo'],
          //img1: res.data[0]['imgs'],
          img1: img1,
          qtd: 1
        }
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaMovsCli = totalPed
        this.loadingMovServItem = false
      })
    },

    salvarMovServ(){
      console.log('salvarMovServ')
      if (this.movServData.fornec && this.movServData.fornec !== ''){
        console.log('salvarMovServ_00')
        this.updating = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/movserv`, {
          movServData: this.movServData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.movServData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0){
            console.log('redirecionar')
            this.$router.replace({ path: `/movserv/editar/${this.movServData.id}` })
            this.idData = this.movServData.id
            this.carregarDados()
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })



      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar fornecedor antes de salvar o movimento",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      var dateString = value;
      var momentObj = moment(dateString, 'YYYY-MM-DD');
      // console.log(momentObj)
      const formatSaida = "DD/MM/YYYY"
      let dateTime = momentObj.format(formatSaida)
      // console.log(dateTime)
      return dateTime
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movServData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvarMovServ" :disabled="movServData.status !== 'EL'" v-if="movServData.status === 'EL'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="movServData.status === 'FA'" @click="downloadDanfe" >
                <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                Imprimir
              </b-button>


              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarMovServ">
                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>
                Copiar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="cancelarMovServ" :disabled="movServData.status !== 'EL'" v-if="movServData.status === 'EL'">
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar Movimento
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoProduto" :disabled="movServData.status !== 'EL'" v-if="movServData.status === 'EL'">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Serviço
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="auditoria" :disabled="movServData.id === 0">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Auditoria
              </b-button>


              <b-button variant="outline-info"
                        class="mx-2"
                        @click="gerarFinanc"
                        v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar Financ (APENAS ADMIN)
              </b-button>


<!--                    <span-->
<!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
<!--                    >-->
<!--                      <i class="mdi mdi-cash"></i>-->
<!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
<!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
<!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button class="btn btn-success"
                      @click="confirmarMovServ"
                      :disabled="movServData.status !== 'EL'"
                      v-if="movServData.status === 'EL' && movServItensData && movServItensData.length > 0">
                <i class="mdi mdi-rocket-launch me-1 text-end"></i> CONFIRMAR!
              </button>


            </div>
          </div>
        </div>
      </div>

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-4">

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <!--                <img-->
                <!--                    src="@/assets/images/users/avatar-2.jpg"-->
                <!--                    alt=""-->
                <!--                    class="avatar-sm rounded-circle img-thumbnail"-->
                <!--                />-->

                <a href="javascript: void(0);" @click="showModalCodigo = true">
                  <span
                      v-if="movServData"
                      class="avatar-title rounded-circle"
                      style="max-height: 55px;
                      min-width: 55px;">{{ movServData.codigo }}
                  </span>
                </a>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="text-muted">

                      <a href="javascript: void(0);"
                         v-if="!clienteData"
                         @click="selecionaCli">
                        <h5 class="mb-1 text-info">Selecionar fornecedor...</h5>
                      </a>

                      <a href="javascript: void(0);"
                         v-if="clienteData"
                         v-b-tooltip.hover
                         placement="top"
                         title="Alterar cliente"
                         @click="selecionaCli">
                        <h5 class="mb-1">{{ clienteData.codigo }} - {{ clienteData.nome }}</h5>
                        <p class="mb-0">{{ clienteData.cidade }}, {{ clienteData.estado }}</p>
                      </a>

                    </div>
                  </div>

                  <router-link :to="`/cliente/detalhe/${clienteData.id}`" class="ms-2" v-if="clienteData" target="_blank">
                    Detalhes Cliente
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>

                </div>
                <hr />
                <div class="row">
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor Total</p>
                      <h5 class="mb-0">R$ {{ movServData.valorliq ?? formatDecimal(movServData.valorliq) }}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso Total</p>
                      <h5 class="mb-0">{{ movServData.peso ?? formatDecimal(movServData.peso) }} kg</h5>
                    </div>
                  </div>

                  <div class="col-4">
                    <div>

                      <a href="javascript: void(0);"  @click="showModalEmissao = true">
                        <p class="text-muted text-truncate mb-2">Data</p>
                        <h5 class="mb-0">{{ formatDate(movServData.dtemissao) }} </h5>
                      </a>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">

              <a href="javascript: void(0);" v-if="!pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ movServData.tipo }}</h5>
              </a>

              <a href="javascript: void(0);"
                 v-if="pedTipoData"
                 v-b-tooltip.hover
                 placement="top"
                 title="Alterar tipo de operação"
                 @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ pedTipoData != null ? pedTipoData.descricao : '' }}</h5>
              </a>

              <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#" @click="selecionaCli">Alterar Cliente</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaCondPgto">Alterar Condição</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaFormaPgto">Alterar Forma de Pagamento</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#" @click="selecionaPedTipo">Alterar Tipo de Operação</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaRepres">Alterar Representante</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaTransp">Alterar Transportadora</b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" v-if="!formaPgtoData" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ movServData.formapgto }}</p>
                </a>
                <a href="javascript: void(0);"
                   v-if="formaPgtoData"
                   v-b-tooltip.hover
                   placement="top"
                   title="Alterar forma de pagamento"
                   @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ formaPgtoData != null ? formaPgtoData.descricao : '' }}</p>
                </a>


                <a href="javascript: void(0);"
                   v-if="condPgtoData"
                   v-b-tooltip.hover
                   placement="top"
                   title="Alterar condição de pagamento"
                   @click="selecionaCondPgto">
                  <h4 class="mb-3">{{ condPgtoData != null ? condPgtoData.descricao : '' }}</h4>
                </a>


                <a href="javascript: void(0);" @click="showModalFinConta = true">
                  <p class="text-success mb-0">
                      <span>{{ movServData.finconta !== null ? movServData.finconta : 'Conta Financ.' }} <i class="mdi mdi-arrow-right ms-1"></i
                      ></span>
                  </p>
                </a>

<!--                <a href="javascript: void(0);"-->
<!--                   v-b-tooltip.hover-->
<!--                   placement="top"-->
<!--                   title="Alterar transportadora"-->
<!--                   @click="alteraTransp">-->
<!--                  <p class="text-success mb-0">-->
<!--                    <span>-->
<!--                      {{ movServData.transp != null ? movServData.transp : 'Trans..' }}-->
<!--                      <i class="mdi mdi-truck-outline ms-1"></i>-->
<!--                    </span>-->
<!--                  </p>-->
<!--                </a>-->


              </div>
              <div class="ms-auto align-self-end">

                <a href="javascript: void(0);"
                   v-b-tooltip.hover
                   placement="top"
                   title="Alterar representante"
                   @click="selecionaRepres">
                  <i href="javascript: void(0);" class="bx bx-wallet display-4 text-light" @click="selecionaRepres">
                    <h4 class="text-muted mb-3">{{ movServData.repres != null ? movServData.repres : '' }}</h4>
                  </i>
                </a>

              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap">
              <div>
                <a href="javascript: void(0);"
                   v-b-tooltip.hover
                   placement="top"
                   title="Alterar observações"
                   @click="alteraObs">
                  <p class="text-warning mb-0">
                      <span>
                        {{ movServData.obs != null ? movServData.obs : 'Observações do Serviço' }}
                        <i class="mdi mdi-chat-alert ms-1"></i>
                      </span>
                  </p>
                </a>
              </div>
            </div>

            <div v-if="movServData.obsnf"
                 class="d-flex flex-wrap text-end">
              <div>
                <a href="javascript: void(0);"
                   v-b-tooltip.hover
                   placement="top"
                   title="Alterar observações"
                   @click="alteraObs">
                  <p class="text-black mb-0">
                      <span>
                        {{ movServData.obsnf != null ? movServData.obsnf : 'Observações da Nota Fiscal' }}
                        <i class="mdi mdi-chat-alert ms-1"></i>
                      </span>
                  </p>
                </a>
              </div>
            </div>

          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento de Valores</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td>Valor Total Bruto</td>
                  <td class="float-end">R$ {{ formatDecimal(movServData.valorbrt) }}</td>
                </tr>
                <tr>
                  <td>Valor Desconto</td>
                  <td class="float-end">R$ {{ formatDecimal(movServData.desconto) }}</td>
                </tr>

                <tr>
                  <td>Margem Bruta</td>
                  <td class="float-end">{{ formatDecimal(margemBruta) }} %</td>
                </tr>

<!--                <tr>-->
<!--                  <td>Valor Frete</td>-->
<!--                  <td class="float-end">-->

<!--                    <a href="javascript: void(0);"-->
<!--                       v-b-tooltip.hover-->
<!--                       placement="top"-->
<!--                       title="Alterar valor do frete"-->
<!--                       @click="alteraFrete">-->
<!--                      <p class="mb-0">-->
<!--                      <span>-->
<!--                        R$ {{ movServData.valorfrt != null ? formatDecimal(movServData.valorfrt) : '0,00' }}-->
<!--                      </span>-->
<!--                      </p>-->
<!--                    </a>-->

<!--                  </td>-->
<!--                </tr>-->
                <tr>
                  <th>Valor Total Líquido</th>
                  <th class="float-end">R$ {{ formatDecimal(movServData.valorliq) }}</th>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto</th>
                  <th>Descrição</th>
                  <th class="text-end">Valor Unit.(R$)</th>
                  <th class="text-end">Quantidade</th>
                  <th class="text-end">Margem (%)</th>
                  <th class="text-end">Desconto (%)</th>
                  <th class="text-end">Valor Total (R$)</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in movServItensData" :key="data.id">

                  <td>
                    <h5 class="text-muted mb-0">{{ data.produto }} </h5>

                  </td>

                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <a href="javascript: void(0);" class="text-body fw-bold text-wrap" @click="editarProduto(data.id)">
                        {{ data.descprod }}
                      </a>
                    </h5>
                    <p class="mb-0">
<!--                      Saldo:-->
<!--                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>-->
                    </p>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrunitliq) }}</td>
                  <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
                  <td class="text-end">{{ formatDecimal(data.margem) }}</td>

                  <td class="text-end">
                    <span class="badge badge-pill badge-soft-success font-size-11" v-if="data.desconto !== 0.00"
                          :class="data.desconto < 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' :  ''">
                      {{ formatDecimal(data.desconto)  }}
                    </span>
                    <span v-else>
                      0.00
                    </span>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                  <td class="text-end">

                    <a href="javascript:void(0);"
                       class="action-icon text-success mx-2"
                       @click="detalhesProduto(data.produto_id)">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movServData.status === 'EL'"
                       class="action-icon text-warning mx-2"
                       @click="editarProduto(data.id)">
                      <i class="mdi mdi-pencil-outline font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movServData.status === 'EL'"
                       class="action-icon text-danger mx-2"
                       @click="deletarMovServItem(data.id)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>

                  </td>

                </tr>



                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>

    </div>


    <b-modal size="lg"
             :title="clienteData != null ? `Detalhes Cliente (${ clienteData.nome })` : 'Detalhes Cliente'"
             v-model="showModalCliente"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Cliente</span>

          <multiselect id="inputCliente"
                       @search-change="pesqCliente"
                       @select="escolheuCli"
                       v-model="movServData.fornec"
                       placeholder="Pesquisar cliente"
                       :options="dtListPesqCli"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingCliente">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCliente && clienteData">
        <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ clienteData.codigo }} </span>
          </p>
        </router-link>
          <p class="mb-2" v-if="movServData.cliender === 1">
              <span class="text-muted" > Entregar: </span>
              <span> {{ clienteData.rua }}, {{ clienteData.numero }}, {{ clienteData.bairro }}  </span>
            <span> | </span>
            <span> {{ clienteData.cidade }} - {{ clienteData.estado }} </span>
          </p>

        <p class="mb-2" v-if="movServData.cliender === 2">
          <span class="text-muted" > Entregar: </span>
          <span> {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}, {{ pessoaEnderData.bairro1 }}  </span>
          <span> | </span>
          <span> {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }} </span>
        </p>

        <p class="mb-2" v-if="movServData.cliender === 3">
          <span class="text-muted" > Entregar: </span>
          <span> {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}, {{ pessoaEnderData.bairro2 }}  </span>
          <span> | </span>
          <span> {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }} </span>
        </p>

        <p class="mb-4" >



        </p>

        <p class="mb-4" >
          <span> {{ clienteData.tel1 }} / {{ clienteData.email }}</span>
        </p>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap">
              <thead>
              <tr>
                <th scope="col">Últimos Movimentos</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Movimentos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">R$ {{ formatDecimal(somaMovsCli / 3) }}</td>
              </tr>
              </tbody>
            </table>
          </div>

      </div>


      <div v-if="clienteData && showSelecionarEnder">
        <div class="mb-2">
          <label>Selecionar Endereço de Entrega:</label>

          <div class="row">

            <div class="col-xl-4 col-sm-4">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                      type="radio"
                      v-model="movServData.cliender"
                      :value="1"
                      name="currency"
                      id="buycurrencyoption1"
                      class="card-radio-input"
                      checked/>
                  <div class="card-radio">
                    <div>
                      <i class="mdi mdi-office-building-marker-outline font-size-24 text-warning align-middle me-2"></i>
                      <span>{{ clienteData.cidade }} - {{ clienteData.estado }}</span>
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1 text-wrap">{{ clienteData.rua }}, {{ clienteData.numero }}</p>
                  <h5 class="font-size-16">{{ clienteData.bairro }} - {{ clienteData.cep }}</h5>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4" v-if="pessoaEnderData">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                      type="radio"
                      v-model="movServData.cliender"
                      :value="2"
                      name="currency"
                      id="buycurrencyoption2"
                      class="card-radio-input"/>
                  <div class="card-radio">
                    <div>
                      <i class="mdi mdi-office-building-marker-outline font-size-24 text-primary align-middle me-2"></i>
                      <span>{{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }}</span>
                    </div>
                  </div>
                </label>
                <div>
                  <p class="text-muted mb-1">{{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}</p>
                  <h5 class="font-size-16">{{ pessoaEnderData.bairro1 }} - {{ pessoaEnderData.cep1 }}</h5>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4" v-if="pessoaEnderData && pessoaEnderData.cidade2">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                      type="radio"
                      v-model="movServData.cliender"
                      :value="3"
                      name="currency"
                      id="buycurrencyoption3"
                      class="card-radio-input"
                  />

                  <div class="card-radio">
                    <div>
                      <i
                          class="mdi mdi-home font-size-24 text-info align-middle me-2"
                      ></i>
                      <span>{{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }}</span>
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1">{{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}</p>
                  <h5 class="font-size-16">{{ pessoaEnderData.bairro2 }} - {{ pessoaEnderData.cep2 }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div>
        <div class="text-start mt-5">
          <a href="javascript: void(0);" @click="showSelecionarEnder = !showSelecionarEnder" >
            <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
            Alterar Endereço de Entrega
          </a>
        </div>
      </div>

      <div>
        <div class="text-start mt-3">
          <router-link  to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Cliente
          </router-link>

        </div>
      </div>


      <div v-if="!loadingCliente && clienteData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalCliente = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCliente">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Tipo de operação" v-model="showModalPedTipo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Tipo de Operação</span>

          <multiselect id="tipooperacao"
                       @search-change="pesqPedTipo"
                       @select="escolheuPedTipo"
                       v-model="movServData.tipo"
                       placeholder="Pesquisar tipo de operação"
                       :options="dtlistPesqPedTipo"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Movimentos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaMovsCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarPedTipo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Forma de Pagamento" v-model="showModalFormaPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Forma de Pagamento</span>

          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="movServData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFormaPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingFormaPgto && formaPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Movimentos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaMovsCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFormaPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFormaPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal title="Detalhes Condição de Pagamento" v-model="showModalCondPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Condição de Pagamento</span>

          <multiselect id="condpgto"
                       @search-change="pesqCondPgto"
                       @select="escolheuCondPgto"
                       v-model="movServData.condpgto"
                       placeholder="Pesquisar condição de pagamento"
                       :options="dtListPesqCondPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4" >

                </span>
                <span class="mx-4" >

                  </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Movimentos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaMovsCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg" title="Alterar Observações" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="obs">Observações do Serviço</label>
          <textarea
              id="obs"
              v-model="movServData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações do Serviço"/>
        </div>

        <div class="mb-3">
          <label for="obsnf">Observações da Nota Fiscal</label>
          <textarea
              id="obsnf"
              v-model="movServData.obsnf"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações da Nota Fiscal"/>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalObs = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg" title="Alterar Número de Documento" v-model="showModalCodigo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="codigo">Número Documento</label>
          <input
              id="codigo"
              v-model="movServData.codigo"
              type="text"
              class="form-control"
              placeholder="Número Documento"/>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCodigo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalCodigo = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Alterar Valor de Frete" v-model="showModalFrete" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="valorfrt">Favor informar o valor do frete</label>
          <input
              id="valorfrt"
              v-model="movServData.valorfrt"
              type="number"
              class="form-control"
              placeholder="Valor do frete (R$)"/>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFrete">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Auditoria" v-model="showModalAuditoria" centered hide-footer>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_by">Usuário Criação</label>
            <input
                id="created_by"
                v-model="movServData.created_by"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Usuário Criação"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_at">Criado em</label>
            <input
                id="created_at"
                v-model="movServData.created_at"
                type="datetime-local"
                class="form-control"
                :disabled="true"
                placeholder="Criado em"/>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_by">Usuário Atualização</label>
            <input
                id="updated_by"
                v-model="movServData.updated_by"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Usuário Atualização"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_at">Atualizado em</label>
            <input
                id="updated_at"
                v-model="movServData.updated_at"
                type="datetime-local"
                class="form-control"
                :disabled="true"
                placeholder="Atualizado em"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">


          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAuditoria = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

          </div>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Representante" v-model="showModalRepres" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Representante</span>

          <multiselect id="repres"
                       @search-change="pesqRepres"
                       @select="escolheuRepres"
                       v-model="movServData.repres"
                       placeholder="Pesquisar representante"
                       :options="dtListPesqRepres"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingRepres">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingRepres && represData">
        <p class="mb-2">
          Representante Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ represData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Nome:
            <span class="text-primary"> {{ represData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Movimentos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaMovsCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalRepres = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarRepres">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Transportadora" v-model="showModalTransp" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect id="repres"
                       @search-change="pesqTransp"
                       @select="escolheuTransp"
                       v-model="movServData.transp"
                       placeholder="Pesquisar transportadora"
                       :options="dtListPesqTransp"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingTransp && transpData">
        <p class="mb-2">
          Transportadora Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ transpData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Nome:
            <span class="text-primary"> {{ transpData.nome }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Movimentos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaMovsCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTransp = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarTransp">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal size="lg"
             :title="movServItemData.id != null ? `Editar Item do Movimento (${ movServItemData.id })` : 'Criar Novo Item no Movimento'"
             v-model="showModalMovServItem"
             @shown="focusProd"
             hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Serviço</span>
          <multiselect id="prodmovservitem"
                       ref="focusThis"
                       @search-change="pesqMovServItem"
                       @select="escolheuMovServItem"
                       v-model="movServItemData.produto"
                       placeholder="Pesquisar novo produto"
                       :options="dtlistPesqMovServItem"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqMovServItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end" >

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>


<!--                  <span class="float-end ">-->
<!--                    <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">-->
<!--                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>-->
<!--                    </span>-->

<!--                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">-->
<!--                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>-->
<!--                    </span>-->

<!--                  </span>-->
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingMovServItem">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingMovServItem && movServItemData && movServItemData.descprod">

        <router-link :to="`/produto/detalhe/${movServItemData.produto_id}`" target="_blank" >
          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
<!--                    <div class="me-2">-->
<!--                      <p class="text-muted mb-2">{{ movServItemData.descprod }}</p>-->
<!--                      <h5 class="mb-0">saldo: {{ formatInteger(movServItemData.saldo) }} ({{ movServItemData.und }})</h5>-->
<!--                    </div>-->
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!movServItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="movServItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="movServItemData.img1" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 155px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info">   {{ movServItemData.produto }} </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(movServItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

<!--            <div class="col-lg-6">-->
<!--              <div class="card mini-stats-wid">-->
<!--                <div class="card-body">-->
<!--                  <div class="d-flex flex-wrap">-->
<!--                    <div class="me-2">-->
<!--                      <p class="text-muted mb-2">Preço concorrente 1</p>-->
<!--                      <h5 class="mb-0">R$ {{ formatDecimal(138) }}</h5>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-6">-->
<!--              <div class="card mini-stats-wid">-->
<!--                <div class="card-body">-->
<!--                  <div class="d-flex flex-wrap">-->
<!--                    <div class="me-2">-->
<!--                      <p class="text-muted mb-2">Preço concorrente 2</p>-->
<!--                      <h5 class="mb-0">R$ {{ formatDecimal(125) }} </h5>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

          </div>
        </router-link>



          <form class="needs-validation" @submit.prevent="confMovServItem">
            <div class="row">

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="vlrunitliq">Valor Unitário</label>
                  <input
                      id="vlrunitliq"
                      v-model="movServItemData.vlrunitliq"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor unitário líquido"
                      :class="{'is-invalid': submitMovServItem && v$.movServItemData.vlrunitliq.$error,}"/>
                  <div v-if="submitMovServItem && v$.movServItemData.vlrunitliq.$error"
                       class="invalid-feedback">
                    <span v-if="v$.movServItemData.vlrunitliq.required.$message">{{ v$.movServItemData.vlrunitliq.required.$message }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="qtd">Quantidade</label>
                  <input
                      id="qtd"
                      v-model="movServItemData.qtd"
                      type="number"
                      class="form-control text-end"
                      placeholder="Quantidade"
                      :class="{'is-invalid': submitMovServItem && v$.movServItemData.qtd.$error,}"/>
                  <div v-if="submitMovServItem && v$.movServItemData.qtd.$error"
                       class="invalid-feedback">
                    <span v-if="v$.movServItemData.qtd.required.$message">{{ v$.movServItemData.qtd.required.$message }}</span>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="vlrir">Valor IR</label>
                  <input
                      id="vlrir"
                      v-model="movServItemData.vlrir"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor IR"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="vlrcontrib">Valor Contrib.</label>
                  <input
                      id="vlrcontrib"
                      v-model="movServItemData.vlrcontrib"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor Contrib."/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="vlrpis">Valor PIS</label>
                  <input
                      id="vlrpis"
                      v-model="movServItemData.vlrpis"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor PIS"/>
                </div>
              </div>




              <div class="col-md-3">
                <div class="mb-3">
                  <label for="vlrcofins">Valor COFINS</label>
                  <input
                      id="vlrcofins"
                      v-model="movServItemData.vlrcofins"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor COFINS"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="vlriss">Valor ISS</label>
                  <input
                      id="vlriss"
                      v-model="movServItemData.vlriss"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor ISS"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="vlrinss">Valor INSS</label>
                  <input
                      id="vlrinss"
                      v-model="movServItemData.vlrinss"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor INSS"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="desconto">Desconto</label>
                  <input
                      id="desconto"
                      v-model="movServItemData.desconto"
                      type="number"
                      class="form-control text-end"
                      placeholder="Desconto"/>
                </div>
              </div>

              <!--              <div class="col-md-2">-->
              <!--                <div class="mb-3">-->
              <!--                  <label for="cofinscst">CST COFINS</label>-->
              <!--                  <input-->
              <!--                      id="cofinscst"-->
              <!--                      v-model="movServItemData.cofinscst"-->
              <!--                      type="text"-->
              <!--                      class="form-control"-->
              <!--                      placeholder="CST COFINS"/>-->
              <!--                </div>-->
              <!--              </div>-->

            </div>

          </form>

        <div class="table-responsive mt-2">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Movimentos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movserv/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Maior compra deste cliente (2 und):</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaMovsCli) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Desconto({{ formatDecimal(movServItemData.desconto) }}%):</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(movServItemData.vlrtotalbrt - movServItemData.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Valor Total Líquido do Item:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(movServItemData.vlrtotalliq) }}</td>
            </tr>
            </tbody>
          </table>
        </div>


        <div class="row text-end" v-if="messageValidacaoItem !== ''">

          <div class="col-md-12">
            <span class="text-danger" > {{ messageValidacaoItem }} * </span>
          </div>

        </div>


        <div class="row">

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalMovServItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confMovServItem" :disabled="messageValidacaoItem !== ''">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>

        </div>

      </div>

    </b-modal>


    <b-modal title="Detalhes Conta" v-model="showModalFinConta" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="condpgto">Selecionar Nova Conta</label>

          <multiselect id="inputFinConta"
                       @search-change="pesqFinConta"
                       @select="escolheuFinConta"
                       v-model="movServData.finconta"
                       placeholder="Pesquisar plano de contas"
                       :options="dtListPesqFinConta"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>

                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                  <span class="mx-4" >
                              {{ slotProps.option.id }}
                            </span>
                </div>
                <div class="mt-2 font-size-16">{{ slotProps.option.descricao }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.nivel }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFinConta">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingFinConta && finContaData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <!--        <router-link :to="`/tiposopera/list`" target="_blank" >-->
        <p class="mb-2">
          Código:
          <span class="text-primary"> {{ finContaData.codigo }} </span>
        </p>

        <p class="mb-2" >
          Descrição:
          <span class="text-primary"> {{ finContaData.descricao }}  </span>
        </p>
        <!--        </router-link>-->


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinConta = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalFinConta = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Alterar Datas Movimento" v-model="showModalEmissao" centered hide-footer>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="dtemissao">Data de Emissão</label>
            <input
                id="dtemissao"
                v-model="movServData.dtemissao"
                type="date"
                class="form-control"
                placeholder="Data de Emissão"/>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="dtmov">Data de Movimento</label>
            <input
                id="dtmov"
                v-model="movServData.dtmov"
                type="date"
                class="form-control"
                placeholder="Data de Movimento"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalEmissao = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="showModalEmissao = false">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>

      </div>




    </b-modal>


  </Layout>
</template>

<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>

